module.exports = __webpack_public_path__ + "static/media/frontend.fce1e090.jpg";